import { render, staticRenderFns } from "./Buffeloviewdetails.vue?vue&type=template&id=d4b6506e&"
import script from "./Buffeloviewdetails.vue?vue&type=script&lang=js&"
export * from "./Buffeloviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports